import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import TransportationRequestDetails from '../common/transportation/transportation-request-details';
import TransportationRequestChips from '../common/transportation/transportation-request-chips';
import RequestPreview from '../common/request/request-preview';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import OfferInfo from '../common/offer-info';
import { Panel, PanelHeader, PanelContent } from '../common/panel';

import { renderAttachment } from '../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const TransportationOffer = () => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState({
        skeleton: true,
        backdrop: false
    });
    const [transportationOffer, setTransportationOffer] = useState(null);
    const [, setError] = useState(null);
    const { id } = useParams();
    let history = useHistory();

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    useEffect(() => {
        axios.get(`/api/transportationoffer/GetByIdAsync/${id}`, { headers: headers })
            .then(res => {
                setTransportationOffer(res.data);
                setTimeout(() => setLoading({ ...loading, skeleton: false }), 500);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [])

    const deleteOffer = () => {
        setLoading({ ...loading, backdrop: true });
        axios.delete(`/api/transportationoffer/${id}`, { headers: headers })
            .then(res => {
                setTimeout(() => history.push(`/request/${transportationOffer.reservationRequestResource.id}/transportation`), 500);

            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }

    return (
        <>
            {
                loading.backdrop ?
                    <Backdrop className="backdrop" open={loading.backdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    :
                    null
            }
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                transportationOffer ?
                                    <>
                                        <RequestPreview
                                            label={"Transportation"}
                                            keyword={"Cities"}
                                            reservationRequest={transportationOffer.reservationRequestResource}
                                            Details={
                                                <TransportationRequestDetails
                                                    transportationResources={transportationOffer.reservationRequestResource.reservationRequestTransportationResources}
                                                />
                                            }
                                            Chips={
                                                <TransportationRequestChips
                                                    variant={"default"}
                                                    transportationResources={transportationOffer.reservationRequestResource.reservationRequestTransportationResources}
                                                />
                                            }
                                        />
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Offer Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                transportationOffer ?
                                    <>
                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Routes:
                                            </Typography>
                                            </Grid>
                                            <Grid container item xs={9}>
                                                {
                                                    transportationOffer.reservationSupplierTransportationOfferRouteResources.map((route, index) => (
                                                        <Grid item xs={12} key={index}>
                                                            <Typography variant="subtitle1" gutterBottom>
                                                                <b>Route {index + 1} Details</b> <br />
                                                                From (Address): {route.fromCityName} ({route.fromAddress}) <br />
                                                                To (Address): {route.toCityName} ({route.toAddress}) <br />
                                                                Route Date/Time: {route.routeDate.substring(0, 10)} {route.movingTime.substring(0, 5)} <br />
                                                                Vehicle Type: {route.vehicleType} <br />
                                                                No. of Cars (Price / Car): {route.noofCars} ({route.carPrice} L.E.)<br />
                                                                Contact Phone Number: {route.contactPhoneNumber}<br />
                                                            </Typography>
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={12} md={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Cancellation Policy:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {transportationOffer.cancellationPolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Attachment:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {renderAttachment(transportationOffer.attachment)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>

                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading.skeleton ?
                                <RequestInfoSkeleton />
                                :
                                transportationOffer ?
                                    <OfferInfo offer={transportationOffer} deleteOffer={deleteOffer} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default TransportationOffer;